export const otherSellerBiddingActions = {
    OTHER_SELLER_BIDDING_STORE_SECURITIES: 'OTHER_SELLER_BIDDING_STORE_SECURITIES',
    OTHER_SELLER_BIDDING_RESET: 'OTHER_SELLER_BIDDING_RESET'
}
